import React, {useState} from "react";
import "../../assets/scss/components/_categoriesList.scss"
import Collapse from "@kunukn/react-collapse";

const CategoriesList = ({categories, selected, onSelect}) => {
  const [isDrop, setIsDrop] = useState(false)

  const isSelected = ({id, wpChildren}) => (
    selected === id || (wpChildren && wpChildren.nodes.map(({id}) => id).includes(selected))
  )

  const handleClick = (id = "") => {
    setIsDrop(!isDrop)
    onSelect(id)
  }

  return (
    <>
      <div className={'categories__list list__dropdown d-md-none'}>
        <button className={'selected'} onClick={handleClick}>
          {categories.find(({id, wpChildren}) => isSelected({id, wpChildren}))?.name || 'All books' }
        </button>

        {isDrop && (
          <div className={'suggestion'}>
            {categories.map(({id, name}) => (
              <div key={id} className={'category'}>
                <button className={'name'} onClick={() => handleClick(id)}>{name}</button>
              </div>
            ))}
          </div>
        )}
      </div>

      <div className={'categories__list d-none d-md-block'}>
        {categories.map(({id, name, wpChildren}) => (
          <div key={id} className={`${isSelected({id, wpChildren}) && 'selected'} category`}>
            <button className={'name'} onClick={() => handleClick(id)}>{name}</button>

            <Collapse isOpen={isSelected({id, wpChildren}) && wpChildren.nodes.length} className={'children'}>
              <div className={'content__border'}>
                {wpChildren.nodes.map(({id, name, slug}) => (
                  <button key={id} className={`${isSelected({id}) && 'selected'} name child`} onClick={() => handleClick(id)}>{name}</button>
                ))}
              </div>
            </Collapse>
          </div>
        ))}
      </div>
    </>
  )
}

export default CategoriesList;
